/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {AppEventBusService} from '../events/app-event-bus.service';
import {AppSharedModule} from '../app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-view-object-states',
  template: `
    <span class="listIncludeLinks">
      <a (click)="selectInclude('ACTIVE')" [class.listIncludeLinksCurrent]="currentInclude === 'ACTIVE'">Active</a>
      <a (click)="selectInclude('INACTIVE')" [class.listIncludeLinksCurrent]="currentInclude === 'INACTIVE'">Archived</a>
      <a *ngIf="!hideHidden" (click)="selectInclude('HIDDEN')" [class.listIncludeLinksCurrent]="currentInclude === 'HIDDEN'">Deleted</a>
    </span>
    <span *ngIf="listIsObject() && !list.includeQuery?.$resolved" style="display: inline-block; margin-left: 5px" class="fa fa-cog fa-spin"></span>
  `
})
export class ViewObjectStatesComponent implements OnInit {
  @Input() list: any;

  hideHidden = false;

  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly eventBus: AppEventBusService
  ) {
  }

  ngOnInit(): void {
    this.hideHidden = this.LocalNetworkProfile.isPureMarketplacePlatform();
  }

  get includeModel(): string {
    if (!this.listIsObject()) {
      return 'ACTIVE';
    }
    return this.list.include || this.list.showingInclude || 'ACTIVE';
  }

  set includeModel(value: string) {
    if (!this.listIsObject()) {
      return;
    }
    this.list.include = value;
  }

  get currentInclude(): string {
    return this.includeModel;
  }

  selectInclude(value: string): void {
    if (this.currentInclude === value) {
      return;
    }
    this.includeModel = value;
    this.onIncludeChange(value);
  }

  onIncludeChange(value: string): void {
    if (!this.listIsObject() || !_.isFunction(this.list.makeIncludeQuery)) {
      return;
    }
    if (this.list.showingInclude === value) {
      return;
    }
    this.list.makeIncludeQuery();
    this.eventBus?.runAsync?.();
  }

  private listIsObject(): boolean {
    return !!this.list && typeof this.list === 'object';
  }
}
